export default "__VITE_ASSET__9333caeb__"